<template>
    <div style="margin:0 -12px;'">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <br>
                        <i class="bi bi-chevron-left" onclick="window.location.href = '/home'"></i>
                    </div>
                    <div class="col text-center" style="padding-top: 25px;">
                        <h5>SMグッズ販売</h5>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <div class="container-fluid" style="padding-top:60px;" v-if="isUserLoaded">
                <br>
                <div class="row" v-if="userCanUseAllFeatures">
                    <div class="col text-center" style="padding:10px;">
                        <a href="https://totonawa.booth.pm/items/4336955" target="_blank">
                            <img src="/images/totonawa_plan.png" style="width:100%;" />
                        </a>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col text-center" style="padding:10px;">
                        <a href="https://totonawa.booth.pm/items/4336942" target="_blank">
                            <img src="/images/totonawa_free.png" style="width:100%;" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: null,
            isUserLoaded: false,
        };
    },
    computed: {
        userCanUseAllFeatures() {
            return !!(this.user && this.user.can_use_all_features);
        },
    },
    methods: {
        async getUserStatus() {
            try {
                const response = await axios.get("/api/user/status");
                this.user = response.data.user;
            } catch (error) {
                if (error.response && error.response.status == 401) {
                    window.location.href = "/auth?logout=true";
                }
                else {
                    this.$showErrorToast('ユーザーの取得に失敗しました。');
                }
            } finally {
                this.isUserLoaded = true;
            }
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.getUserStatus()
                        })
                    .catch((error) => {
                        this.$showErrorToast('ユーザーの取得に失敗しました。');
                    })
            }
            else {
                this.getUserStatus()
            }
        }
        else {
            this.getUserStatus()
        }
    },
};
</script>
<style>
#tab_detail_1 {
    animation: fadein 1.5s forwards
}
</style>
